function FTInitialValues(state, fixedValues) {
  return {
    sendersFinancialInstitutionCode: sendersCode(state),
    destinationInstitutionCode: fixedValues.destination_code || "",
    channelCode: fixedValues.channel_code || "",
    randomNumber: "",
    timeStamp: fixedValues.time_stamp || "",
    nameEnquiryRef: fixedValues.nameEnquiryRef || "",
    beneficiaryAccountName: fixedValues.beneficiaryAccountName || "",
    beneficiaryAccountNumber: fixedValues.beneficiaryAccountNumber || "",
    beneficiaryBankVerificationNumber: fixedValues.beneficiaryBankVerificationNumber || "",
    beneficiaryKYCLevel: fixedValues.beneficiaryKYCLevel || "",
    originatorAccountName: accountName(state),
    originatorAccountNumber: accountNumber(state) || "",
    originatorBankVerificationNumber: bankVerificationNo(state),
    transactionLocation: transactionLocation(state),
    narration: narration(state),
    paymentReference: paymentRef(state),
    amount: (state.fundTransfer && state.fundTransfer.amount) || "",
    originatorKYCLevel: kycLevel(state),
  };
}

export default FTInitialValues;
function paymentRef(state) {
  return (state.fundTransfer && state.fundTransfer.paymentReference) || "";
}

function narration(state) {
  return (state.fundTransfer && state.fundTransfer.narration) || "";
}

function accountName(state) {
  return (state.fundTransfer && state.fundTransfer.originatorAccountName) || "";
}

function kycLevel(state) {
  return (state.fundTransfer && state.fundTransfer.originatorKYCLevel) || "";
}

function accountNumber(state) {
  return (state.fundTransfer && state.fundTransfer.originatorAccountNumber);
}

function transactionLocation(state) {
  return (state.fundTransfer && state.fundTransfer.transactionLocation) || "";
}

function bankVerificationNo(state) {
  return (state.fundTransfer &&
    state.fundTransfer.originatorBankVerificationNumber) ||
    "";
}

function sendersCode(state) {
  return (state.fundTransfer && state.fundTransfer.session_id) || "";
}

